import React from 'react';

interface VenereLogoProps {
  width?: number | string;
  height?: number | string;
  className?: string;
  color?: string;
  onClick?: () => void;
}

export const VenereLogo: React.FC<VenereLogoProps> = ({
  width = 108,
  height = 108,
  className = '',
  color = 'currentColor',
  onClick
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 450 1100 150"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      onClick={onClick}
      style={{ cursor: onClick ? 'pointer' : 'default' }}
    >
      <path
        d="M770.48,494.3v14.53c-2.62-5.24-6.58-9.29-11.88-12.17-5.3-2.88-11.55-4.32-18.75-4.32s-14.27,1.87-20.81,5.6c-6.54,3.73-11.84,9.23-15.9,16.49-4.06,7.26-6.09,15.94-6.09,26.01s2.03,18.78,6.09,26.11c4.06,7.33,9.36,12.86,15.9,16.59,6.54,3.73,13.48,5.6,20.81,5.6.86,0,1.69-.03,2.51-.06.06,0,.12,0,.18,0,13.94-.7,20.87-6.74,28.39-9.42,2.17-.77,4.4-1.27,6.85-1.27,6.93,0,12.04,3.46,16.05,10.76v-94.43h-23.36ZM762.93,559.97c-4.65,4.65-10.18,6.97-16.59,6.97-7.07,0-12.96-2.42-17.67-7.26-4.71-4.84-7.07-11.26-7.07-19.24s2.36-14.2,7.07-19.04c4.71-4.84,10.6-7.26,17.67-7.26,3.93,0,7.69,1.05,11.29,3.14,3.6,2.09,6.54,5.14,8.83,9.13,2.29,3.99,3.44,8.67,3.44,14.04,0,8.38-2.32,14.89-6.97,19.53Z"
        fill={color}
      />
      <path
        d="M373.31,532.77v54.01h-24.94v-50.08c0-7.72-1.7-13.35-5.11-16.89-3.4-3.53-7.72-5.3-12.96-5.3-6.02,0-10.9,2.26-14.63,6.77-3.73,4.52-5.6,10.38-5.6,17.58v47.92h-24.75v-133.94h24.75v54.79c3.01-4.71,7-8.41,11.98-11.1,4.97-2.68,10.47-4.03,16.5-4.03,10.08,0,18.39,3.4,24.94,10.21,6.55,6.81,9.82,16.82,9.82,30.05Z"
        fill={color}
      />
      <path
        d="M386.84,565c-4.25-7.33-6.38-15.51-6.38-24.55s2.13-17.22,6.38-24.55c4.26-7.33,10.11-13.09,17.58-17.28,7.46-4.19,15.91-6.28,25.33-6.28s17.87,2.09,25.33,6.28c7.46,4.19,13.32,9.95,17.58,17.28,4.26,7.33,6.38,15.51,6.38,24.55s-2.13,17.22-6.38,24.55c-4.26,7.33-10.11,13.13-17.58,17.38-7.46,4.26-15.91,6.38-25.33,6.38s-17.87-2.13-25.33-6.38c-7.46-4.26-13.32-10.05-17.58-17.38ZM454.5,540.45c0-7.72-2.32-14.07-6.97-19.05-4.65-4.98-10.57-7.46-17.77-7.46s-13.13,2.49-17.77,7.46c-4.65,4.98-6.97,11.32-6.97,19.05s2.32,14.24,6.97,19.15c4.65,4.91,10.57,7.36,17.77,7.36s13.13-2.45,17.77-7.36c4.65-4.91,6.97-11.29,6.97-19.15Z"
        fill={color}
      />
      <path
        d="M486.19,586.78v-133.94h24.74v133.94h-24.74Z"
        fill={color}
      />
      <path
        d="M517.25,464.62c0-4.19,1.54-7.79,4.61-10.8,3.08-3.01,6.78-4.52,11.1-4.52s7.82,1.51,10.9,4.52c3.08,3.01,4.62,6.61,4.62,10.8s-1.54,7.76-4.62,10.7c-3.08,2.95-6.71,4.42-10.9,4.42s-8.02-1.47-11.1-4.42c-3.08-2.95-4.61-6.51-4.61-10.7ZM520.59,586.78v-92.3h24.75v92.3h-24.75Z"
        fill={color}
      />
      <path
        d="M579.54,494.47v-6.09c0-10.6,5.56-15.91,16.69-15.91.92,0,2.81.13,5.7.39v-19.84c-4.98-1.05-9.36-1.57-13.16-1.57-10.21,0-18.43,3.21-24.65,9.62-6.22,6.41-9.33,15.78-9.33,28.08v97.6h24.75v-72.47h16.65v-19.84h-16.65Z"
        fill={color}
      />
      <path
        d="M665.17,494.49v47.92c0,7.2-1.87,13.06-5.6,17.58-3.73,4.52-8.61,6.77-14.63,6.77-5.24,0-9.56-1.77-12.96-5.3-3.4-3.53-5.11-9.17-5.11-16.89v-50.08h-24.94v54.01c0,13.22,3.27,23.24,9.82,30.05,6.55,6.81,14.86,10.21,24.94,10.21,6.02,0,11.52-1.34,16.5-4.03,4.98-2.68,8.97-6.38,11.98-11.1v13.75c0,6.81-1.6,12.05-4.81,15.71-3.21,3.66-8.08,5.5-14.63,5.5-4.84,0-8.64-1.08-11.39-3.24-2.75-2.16-4.52-5.01-5.3-8.54h-24.94c1.31,9.82,5.43,17.87,12.37,24.16,6.94,6.28,16.82,9.43,29.66,9.43,14.14,0,24.97-4.06,32.5-12.18,7.53-8.12,11.29-19.38,11.29-33.78v-89.95h-24.75Z"
        fill={color}
      />
    </svg>
  );
}; 